import "./PlayTable.scss";
import {
  CloverB,
  HeartB,
  PikesB,
  TilesB,
} from "../../../../styles/images/SuitsImgBordered";
import {Joker} from "../../../../styles/images/SuitsImgWthoutBorder";
import {useTranslation} from "react-i18next";

const PlayTable = ({getRoundID}) => {
  const {t} = useTranslation();

  return (
    <div className="play-table">
        <div className="play-table-title play-table-box round">
          <h3>{t('round').toUpperCase()} #{getRoundID}</h3>
        </div>
      <div className="play-table-box">
        <div className="play-table-title">
          <h3>{t('pay table')}</h3>
        </div>
        <div className="suits">
          <h3>{t('suits')}</h3>
          <div className="suits-item">
            <HeartB/>
            <PikesB/>
            <TilesB/>
            <CloverB/>
          </div>
          <h3>X 4</h3>
        </div>

        <div className="suits">
          <h3>{t('joker')}</h3>
          <Joker/>
          <h3>X36</h3>
        </div>
      </div>

      <div className="play-table-box">
        <div className="play-table-title">
          <h3>{t('pay table')} #2</h3>
        </div>

        <div className="bet-sector sector">
          <h3>{t('sector')}</h3>
          <div>
            <h2>A</h2>
            <h2>B</h2>
            <h2>C</h2>
            <h2>D</h2>
            <h2>E</h2>
            <h2>F</h2>
          </div>
          <h3>X 6</h3>
        </div>

        <div className="bet-sector dozen">
          <h3>{t('dozens')}</h3>
          <div className="dozen-numbers">
            <div>
              <h2>1</h2>
              <span>1-12</span>
            </div>
            <div>
              <h2>2</h2>
              <span>13-24</span>
            </div>
            <div>
              <h2>3</h2>
              <span>25-36</span>
            </div>
          </div>
          <h3>X 3</h3>
        </div>

        <div className="bet-sector color">
          <h3>{t('colors')}</h3>
          <div className="colors-sector">
            <div></div>
            <div></div>
          </div>
          <h3>X 2</h3>
        </div>

        <div className="bet-sector">
          <h3>{t('even odd')}</h3>
          <h3>X 2</h3>
        </div>

        <div className="bet-sector under-over">
          <h3>{t('under over')}</h3>
          <div>
            <h2>1-18 / 19-36</h2>
          </div>
          <h3>X 2</h3>
        </div>

        <div className="bet-sector">
          <h3>{t('number')}</h3>
          <h3>X 36</h3>
        </div>
      </div>
    </div>
  );
};

export default PlayTable;
